var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editablelist"},[_c('ul',[_vm._t("default")],2),_vm._v(" "),_c('textButton',{staticClass:"top-distance",nativeOn:{"click":function($event){return _vm.addItem(_vm.editablelist)}}},[_vm._v("新增")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60021906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editablelist/editablelist.vue
// module id = t3XW
// module chunks = 33